import "./Support.css";
import { useState, useEffect } from "react";
import MainPopup from "./component/MainPopup";
import { BASEURL, getNotifications } from "./utils/api/tickets";
import ActionCable from "actioncable";
import { useOnboardingTourData } from "../containers/authorised/onboarding/OnBoardingCustomHooks";
import { handleOnboardingTourStart } from "../containers/authorised/onboarding/onBoardingHelpers";

function Support() {
  const [view, setView] = useState(false);
  const [notifications, setNotifications] = useState(false);
  const onBoardingTourData = useOnboardingTourData()

  useEffect(() => {
    setTimeout(function () {
      var cable = ActionCable.createConsumer(
        `${BASEURL}cable?token=${localStorage.getItem(
          "User-email"
        )}`
      );
      cable.subscriptions.create(
        {
          channel: "OnlineNotificationsChannel",
        },
        {
          connected: function () {
            console.log("Support Socket connected");
          },
          disconnected: function () {
            console.log("Support Socket disconnected");
          },
          received: function (data) {
            setNotifications(true);
            console.log(`notification received`);
          },
          speak: function (message) {
            return this.perform("speak", {
              message: message,
            });
          },
        }
      );
    }, 4000);
  }, []);

  useEffect(() => {
    handleGetNotifiction();
  }, []);

  const handleGetNotifiction = async () => {
    const response = await getNotifications();
    for (let i = 0; i < response.length; i++) {
      if (response[i].seen === false) {
        setNotifications(true);
        break;
      } else {
        setNotifications(false);
      }
    }
  };

  const handleOnboardingTourReplay = () => {
    setView(false)
    handleOnboardingTourStart(onBoardingTourData)
  }

  return (
    <>
      {view !== false && (
        <MainPopup
          setView={setView}
          handleOnboardingTourReplay={handleOnboardingTourReplay}
        />
      )}

      <button
        className={`bg-primary position-relative main-btn rounded-circle border-0 `}
        onClick={() => (view ? setView(false) : setView("Menu"))}
      >
        <svg
          width="12"
          height="7"
          viewBox="0 0 35 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${view && "rotate-90"}`}
        >
          <circle cx="3.5" cy="3.5" r="3.5" fill="white" />
          <circle cx="17.5" cy="3.5" r="3.5" fill="white" />
          <circle cx="31.5" cy="3.5" r="3.5" fill="white" />
        </svg>
        {notifications && (
          <span className="position-absolute notification-icon translate-middle p-2 bg-danger border border-light rounded-circle"></span>
        )}
      </button>
    </>
  );
}

export default Support;
